// For all the special chars white listed - // Allow: ", -, _, =, ;, :, ', ,, ., <, >, &, /, \
export const avoidXSSattack = (event: any) => {
  let ev = { ...event };
  // ev.target.value = ev.target.value.replace(/(<([^>]+)>)/gi, "");
  ev.target.value = event.target.value.replace(
    /[^a-zA-Z0-9"\-_=;:',.<>\/\\&\s]/g,
    ""
  );
  let value = ev.target.value;
  ev.target.value =
    value.startsWith("@") ||
    value.startsWith("+") ||
    value.startsWith("-") ||
    value.startsWith("=")
      ? ev.target.value.replace(/[@=+-]/g, "")
      : ev.target.value;
  return ev;
};

export const avoidXSSattackforStepDescription = (event: any) => {
  let ev = { ...event };
  ev.target.value = ev.target.value.replace(
    /[^a-zA-Z0-9"\-_=;:',.<>\/\\&\s]/g,
    ""
  );
  let value = ev.target.value;
  ev.target.value =
    value.startsWith("@") ||
    value.startsWith("+") ||
    value.startsWith("-") ||
    value.startsWith("=")
      ? ev.target.value.replace(/[@=+-]/g, "")
      : ev.target.value;
  return ev;
};

export const avoidXSSattackMinimalSpecCharAllowed = (event: any) => {
  let ev = { ...event };
  ev.target.value = event.target.value.replace(
    /[^a-zA-Z0-9"\-_=;:',.<>\/\\&\s]/g,
    ""
  );
  let value = ev.target.value;
  ev.target.value = /^[ "\-_=;:',.<>\/\\&]+/.test(value)
    ? ev.target.value.replace(/^[ "\-_=;:',.<>\/\\&]+/, "")
    : ev.target.value;
  return ev;
};

export const avoidXSSattackOnReportLibrary = (event: any) => {
  let ev = { ...event };
  ev.target.value = event.target.value.replace(
    /[^a-zA-Z0-9"\-_=;:',.<>\/\\&\s]/g,
    ""
  );
  let value = ev.target.value;
  ev.target.value = /^[ "\-_=;:',.<>\/\\&]+/.test(value)
    ? ev.target.value.replace(/^[ "\-_=;:',.<>\/\\&]+/, "")
    : ev.target.value;
  return ev;
};

export const avoidXSSattackOnReportName = (event: any) => {
  let ev = { ...event };
  ev.target.value = event.target.value.replace(
    /[^a-zA-Z0-9"\-_=;:',.<>\/\\&\s()]/g,  // <-- Includes ()
    ""
  );
  let value = ev.target.value;
  ev.target.value = /^[ "\-_=;:',.<>\/\\&()]+/.test(value)
    ? ev.target.value.replace(/^[ "\-_=;:',.<>\/\\&()]+/, "")
    : ev.target.value;
  return ev;
};

// export const isValidHttpsUrl = (url: string) => {
//   return /^https:\/\/.+/.test(url);
// };

export const isValidHttpOrHttpsUrl = (url: string) => {
  return /^(https?:\/\/).+/.test(url);
};

